export default __webpack_public_path__ + "media/images/contact-dog-body-696466f19a3430a99d5293bc9826b78d.svg";